// extracted by mini-css-extract-plugin
export default {"card":"PaymentCard_card__kZnq4","header":"PaymentCard_header__pISRF","icon":"PaymentCard_icon__eW3zr","subtitle":"PaymentCard_subtitle__gpGch"};